module.exports = __webpack_public_path__ + "img/clinic-facade-del-icon.91f56529.svg";